import { ChatParticipant, OrganizationMember } from '@prisma/client'
import { useMemo } from 'react'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { OrganizationMemberClientShared } from '~/features/organizationMember/clientShared'

type Props = {
  organizationMember: OrganizationMember
  organizationMembers: OrganizationMemberFromContext[]
  participants: ChatParticipant[]
}

export const useOtherParticipants = ({
  organizationMembers,
  organizationMember,
  participants,
}: Props) => {
  const members = useMemo(() => {
    return participants
      .map(participant => {
        const member = organizationMembers.find(
          candidate => candidate.id === participant.organizationMemberId,
        )
        return member
      })
      .filter(member => !!member && member.id !== organizationMember.id)
      .map(member => {
        const name = OrganizationMemberClientShared.Helper.getName(member)
        const role = OrganizationMemberClientShared.Helper.getRole(member)
        const pictureUrl =
          OrganizationMemberClientShared.Helper.getPictureUrl(member)
        return { name, pictureUrl, role, organizationMember: member }
      })
  }, [participants, organizationMember, organizationMembers])

  return {
    members,
  }
}
